import React from "react";
import { Section } from "../../../components/section";
import { InsightOverview } from "../../../components/insight-overview";
import { MethodOverview } from "../../../components/method-overview";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { SectionHeader } from "../../../components/section-header";
import Pretotype from "../../../images/pretotype.png"
import Storyboard from "../../../images/storyboard.png"

export interface IOpportunitiesProps {
    sectionId: string;
    index: number;
}

export function Opportunities(props: IOpportunitiesProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Exploration`}
            />
            <ParagraphGroup
                body={
                    [
                        "We then focused on finding human-AI collaboration strategies that can work together as a system to create new and better norms for users and platforms. While AI is by no means a silver bullet solution, it has the greatest potential for immediate positive effects given the speed at which misinformation travels.",
                        "To understand the optimal way for humans and machines to work together, we created a pretotype and conducted speed dating sessions with platform users."
                    ]
                }
            />
            <MethodOverview
                methods={
                    [
                        {
                            title: "Pretotype",
                            body: "We created and tested information evaluation techniques, including AI, with participants to uncover the necessary ingredients behind evaluating credibility.",
                            imgSrc: Pretotype
                        },
                        {
                            title: "Speed Dating",
                            body: "We explored a spectrum of solutions with users, ranging from non-AI to full-AI interventions, to test the boundaries of trust and human-AI collaboration. ",
                            imgSrc: Storyboard
                        }
                    ]
                }
            />
            <InsightOverview
                insights={
                    [
                        {
                            title: "Align User and AI Goals",
                            body: "In order to trust an AI system, users need to feel that the AI is helping them meet existing goals, rather than creating goals for them.",
                        }

                    ]
                }
            />
            <ParagraphGroup
                body={
                    [
                        "Users are wary of AI monitoring their behavior on social platforms, but when we dug into this sentiment, we found a more nuanced perception of AI. Users can accept algorithmic tracking when the AI system helps them meet their goals, but may react negatively if they perceive that the AI's goal conflicts with their own. In order to make the model feel personalized and helpful to each user, AI should learn and adapt to user behavior as much as possible."
                    ]
                }
            />
        </Section>
    );
}
